/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/bankreconciliation/service.proto" (package "rd.api.bankreconciliation", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ReconciliationMatchGroup } from "../../bankreconciliation/models_pb";
import { ExternalTransaction } from "../../accounting/models_pb";
import { ImportedTransaction } from "../../bankreconciliation/models_pb";
import { ExternalTransaction_PaymentMethod } from "../../accounting/models_pb";
import { Money } from "../../proto/money/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { UUID } from "../../proto/uuid/models_pb";
import { BankReconciliation } from "../../bankreconciliation/models_pb";
import { ExternalAccount } from "../../accounting/models_pb";
/**
 * @generated from protobuf message rd.api.bankreconciliation.ListAccountsAndReconciliationsReq
 */
export interface ListAccountsAndReconciliationsReq {
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.ListAccountsAndReconciliationsRes
 */
export interface ListAccountsAndReconciliationsRes {
    /**
     * @generated from protobuf field: repeated rd.api.bankreconciliation.ListAccountsAndReconciliationsRes.AccountWithReconciliations accounts = 1
     */
    accounts: ListAccountsAndReconciliationsRes_AccountWithReconciliations[];
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.ListAccountsAndReconciliationsRes.AccountWithReconciliations
 */
export interface ListAccountsAndReconciliationsRes_AccountWithReconciliations {
    /**
     * @generated from protobuf field: rd.accounting.ExternalAccount account = 1
     */
    account?: ExternalAccount;
    /**
     * @generated from protobuf field: repeated rd.bankreconciliation.BankReconciliation reconciliations = 2
     */
    reconciliations: BankReconciliation[];
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.CreateReconciliationReq
 */
export interface CreateReconciliationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 1
     */
    externalAccountId?: UUID;
    /**
     * @generated from protobuf field: bytes statement_file = 2
     */
    statementFile: Uint8Array;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp statement_start_date = 3
     */
    statementStartDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp statement_end_date = 4
     */
    statementEndDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money statement_starting_balance = 5
     */
    statementStartingBalance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money statement_ending_balance = 6
     */
    statementEndingBalance?: Money;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.CreateReconciliationRes
 */
export interface CreateReconciliationRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.CompleteReconciliationReq
 */
export interface CompleteReconciliationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID delete_match_ids = 2
     */
    deleteMatchIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID accepted_match_ids = 3
     */
    acceptedMatchIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.api.bankreconciliation.NewMatch new_matches = 4
     */
    newMatches: NewMatch[];
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.CompleteReconciliationRes
 */
export interface CompleteReconciliationRes {
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.VoidReconciliationReq
 */
export interface VoidReconciliationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
    /**
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.VoidReconciliationRes
 */
export interface VoidReconciliationRes {
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.ReopenReconciliationReq
 */
export interface ReopenReconciliationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.ReopenReconciliationRes
 */
export interface ReopenReconciliationRes {
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.RecordMatchingTransactionReq
 */
export interface RecordMatchingTransactionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID imported_transaction_ids = 2
     */
    importedTransactionIds: UUID[];
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 3
     */
    allocationsByChartOfAccountId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction.PaymentMethod payment_method = 5
     */
    paymentMethod: ExternalTransaction_PaymentMethod;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 6
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 7
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 8
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp transacted_at = 9
     */
    transactedAt?: Timestamp; // amount and type come from the imported transaction
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.RecordMatchingTransactionRes
 */
export interface RecordMatchingTransactionRes {
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.ImportAndValidateStatementReq
 */
export interface ImportAndValidateStatementReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 1
     */
    externalAccountId?: UUID;
    /**
     * @generated from protobuf field: bytes statement_file = 2
     */
    statementFile: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.ImportAndValidateStatementRes
 */
export interface ImportAndValidateStatementRes {
    /**
     * @generated from protobuf field: int32 num_transactions = 1
     */
    numTransactions: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp suggested_start_date = 2
     */
    suggestedStartDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp suggested_end_date = 3
     */
    suggestedEndDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_starting_balance = 4
     */
    suggestedStartingBalance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_ending_balance = 5
     */
    suggestedEndingBalance?: Money;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.GetReconciliationReq
 */
export interface GetReconciliationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.GetReconciliationRes
 */
export interface GetReconciliationRes {
    /**
     * @generated from protobuf field: rd.bankreconciliation.BankReconciliation reconciliation = 1
     */
    reconciliation?: BankReconciliation;
    /**
     * @generated from protobuf field: repeated rd.api.bankreconciliation.GetReconciliationRes.MatchWithTransactions matches = 2
     */
    matches: GetReconciliationRes_MatchWithTransactions[];
    /**
     * @generated from protobuf field: repeated rd.bankreconciliation.ImportedTransaction imported_transactions = 3
     */
    importedTransactions: ImportedTransaction[];
    /**
     * @generated from protobuf field: repeated rd.accounting.ExternalTransaction unmatched_external_transactions = 4
     */
    unmatchedExternalTransactions: ExternalTransaction[];
    /**
     * @generated from protobuf field: rd.accounting.ExternalAccount account = 5
     */
    account?: ExternalAccount;
    /**
     * @generated from protobuf field: bool is_latest = 6
     */
    isLatest: boolean;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.GetReconciliationRes.MatchWithTransactions
 */
export interface GetReconciliationRes_MatchWithTransactions {
    /**
     * @generated from protobuf field: rd.bankreconciliation.ReconciliationMatchGroup match = 1
     */
    match?: ReconciliationMatchGroup;
    /**
     * @generated from protobuf field: repeated rd.bankreconciliation.ImportedTransaction imported_transactions = 2
     */
    importedTransactions: ImportedTransaction[];
    /**
     * @generated from protobuf field: repeated rd.accounting.ExternalTransaction external_transactions = 3
     */
    externalTransactions: ExternalTransaction[];
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.UpdateReconciliationMatchesReq
 */
export interface UpdateReconciliationMatchesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID delete_match_ids = 2
     */
    deleteMatchIds: UUID[]; // suggested or active are hard deleted
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID accepted_match_ids = 3
     */
    acceptedMatchIds: UUID[]; // suggested -> active
    /**
     * @generated from protobuf field: repeated rd.api.bankreconciliation.NewMatch new_matches = 4
     */
    newMatches: NewMatch[]; // created as active
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.UpdateReconciliationMatchesRes
 */
export interface UpdateReconciliationMatchesRes {
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.PrintReconciliationPDFReq
 */
export interface PrintReconciliationPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID reconciliation_id = 1
     */
    reconciliationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.bankreconciliation.PrintReconciliationPDFRes
 */
export interface PrintReconciliationPDFRes {
    /**
     * @generated from protobuf field: bytes pdf_bytes = 1
     */
    pdfBytes: Uint8Array;
    /**
     * @generated from protobuf field: string file_name = 2
     */
    fileName: string;
}
/**
 * Shared by every request which adds a new match to a reconciliation
 *
 * @generated from protobuf message rd.api.bankreconciliation.NewMatch
 */
export interface NewMatch {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID imported_transaction_ids = 1
     */
    importedTransactionIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID external_transaction_ids = 2
     */
    externalTransactionIds: UUID[];
}
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountsAndReconciliationsReq$Type extends MessageType<ListAccountsAndReconciliationsReq> {
    constructor() {
        super("rd.api.bankreconciliation.ListAccountsAndReconciliationsReq", []);
    }
    create(value?: PartialMessage<ListAccountsAndReconciliationsReq>): ListAccountsAndReconciliationsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListAccountsAndReconciliationsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountsAndReconciliationsReq): ListAccountsAndReconciliationsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountsAndReconciliationsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.ListAccountsAndReconciliationsReq
 */
export const ListAccountsAndReconciliationsReq = new ListAccountsAndReconciliationsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountsAndReconciliationsRes$Type extends MessageType<ListAccountsAndReconciliationsRes> {
    constructor() {
        super("rd.api.bankreconciliation.ListAccountsAndReconciliationsRes", [
            { no: 1, name: "accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListAccountsAndReconciliationsRes_AccountWithReconciliations }
        ]);
    }
    create(value?: PartialMessage<ListAccountsAndReconciliationsRes>): ListAccountsAndReconciliationsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accounts = [];
        if (value !== undefined)
            reflectionMergePartial<ListAccountsAndReconciliationsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountsAndReconciliationsRes): ListAccountsAndReconciliationsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.bankreconciliation.ListAccountsAndReconciliationsRes.AccountWithReconciliations accounts */ 1:
                    message.accounts.push(ListAccountsAndReconciliationsRes_AccountWithReconciliations.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountsAndReconciliationsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.bankreconciliation.ListAccountsAndReconciliationsRes.AccountWithReconciliations accounts = 1; */
        for (let i = 0; i < message.accounts.length; i++)
            ListAccountsAndReconciliationsRes_AccountWithReconciliations.internalBinaryWrite(message.accounts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.ListAccountsAndReconciliationsRes
 */
export const ListAccountsAndReconciliationsRes = new ListAccountsAndReconciliationsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountsAndReconciliationsRes_AccountWithReconciliations$Type extends MessageType<ListAccountsAndReconciliationsRes_AccountWithReconciliations> {
    constructor() {
        super("rd.api.bankreconciliation.ListAccountsAndReconciliationsRes.AccountWithReconciliations", [
            { no: 1, name: "account", kind: "message", T: () => ExternalAccount },
            { no: 2, name: "reconciliations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BankReconciliation }
        ]);
    }
    create(value?: PartialMessage<ListAccountsAndReconciliationsRes_AccountWithReconciliations>): ListAccountsAndReconciliationsRes_AccountWithReconciliations {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reconciliations = [];
        if (value !== undefined)
            reflectionMergePartial<ListAccountsAndReconciliationsRes_AccountWithReconciliations>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountsAndReconciliationsRes_AccountWithReconciliations): ListAccountsAndReconciliationsRes_AccountWithReconciliations {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.ExternalAccount account */ 1:
                    message.account = ExternalAccount.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* repeated rd.bankreconciliation.BankReconciliation reconciliations */ 2:
                    message.reconciliations.push(BankReconciliation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountsAndReconciliationsRes_AccountWithReconciliations, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.ExternalAccount account = 1; */
        if (message.account)
            ExternalAccount.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.bankreconciliation.BankReconciliation reconciliations = 2; */
        for (let i = 0; i < message.reconciliations.length; i++)
            BankReconciliation.internalBinaryWrite(message.reconciliations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.ListAccountsAndReconciliationsRes.AccountWithReconciliations
 */
export const ListAccountsAndReconciliationsRes_AccountWithReconciliations = new ListAccountsAndReconciliationsRes_AccountWithReconciliations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateReconciliationReq$Type extends MessageType<CreateReconciliationReq> {
    constructor() {
        super("rd.api.bankreconciliation.CreateReconciliationReq", [
            { no: 1, name: "external_account_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "statement_file", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } },
            { no: 3, name: "statement_start_date", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 4, name: "statement_end_date", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 5, name: "statement_starting_balance", kind: "message", T: () => Money, options: { "rd.validator.require": true } },
            { no: 6, name: "statement_ending_balance", kind: "message", T: () => Money, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreateReconciliationReq>): CreateReconciliationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statementFile = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<CreateReconciliationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateReconciliationReq): CreateReconciliationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID external_account_id */ 1:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                case /* bytes statement_file */ 2:
                    message.statementFile = reader.bytes();
                    break;
                case /* google.protobuf.Timestamp statement_start_date */ 3:
                    message.statementStartDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.statementStartDate);
                    break;
                case /* google.protobuf.Timestamp statement_end_date */ 4:
                    message.statementEndDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.statementEndDate);
                    break;
                case /* rd.proto.money.Money statement_starting_balance */ 5:
                    message.statementStartingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.statementStartingBalance);
                    break;
                case /* rd.proto.money.Money statement_ending_balance */ 6:
                    message.statementEndingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.statementEndingBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateReconciliationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID external_account_id = 1; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bytes statement_file = 2; */
        if (message.statementFile.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.statementFile);
        /* google.protobuf.Timestamp statement_start_date = 3; */
        if (message.statementStartDate)
            Timestamp.internalBinaryWrite(message.statementStartDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp statement_end_date = 4; */
        if (message.statementEndDate)
            Timestamp.internalBinaryWrite(message.statementEndDate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money statement_starting_balance = 5; */
        if (message.statementStartingBalance)
            Money.internalBinaryWrite(message.statementStartingBalance, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money statement_ending_balance = 6; */
        if (message.statementEndingBalance)
            Money.internalBinaryWrite(message.statementEndingBalance, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.CreateReconciliationReq
 */
export const CreateReconciliationReq = new CreateReconciliationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateReconciliationRes$Type extends MessageType<CreateReconciliationRes> {
    constructor() {
        super("rd.api.bankreconciliation.CreateReconciliationRes", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateReconciliationRes>): CreateReconciliationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateReconciliationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateReconciliationRes): CreateReconciliationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateReconciliationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.CreateReconciliationRes
 */
export const CreateReconciliationRes = new CreateReconciliationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompleteReconciliationReq$Type extends MessageType<CompleteReconciliationReq> {
    constructor() {
        super("rd.api.bankreconciliation.CompleteReconciliationReq", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "delete_match_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "accepted_match_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "new_matches", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NewMatch }
        ]);
    }
    create(value?: PartialMessage<CompleteReconciliationReq>): CompleteReconciliationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.deleteMatchIds = [];
        message.acceptedMatchIds = [];
        message.newMatches = [];
        if (value !== undefined)
            reflectionMergePartial<CompleteReconciliationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CompleteReconciliationReq): CompleteReconciliationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                case /* repeated rd.proto.uuid.UUID delete_match_ids */ 2:
                    message.deleteMatchIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID accepted_match_ids */ 3:
                    message.acceptedMatchIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.api.bankreconciliation.NewMatch new_matches */ 4:
                    message.newMatches.push(NewMatch.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CompleteReconciliationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID delete_match_ids = 2; */
        for (let i = 0; i < message.deleteMatchIds.length; i++)
            UUID.internalBinaryWrite(message.deleteMatchIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID accepted_match_ids = 3; */
        for (let i = 0; i < message.acceptedMatchIds.length; i++)
            UUID.internalBinaryWrite(message.acceptedMatchIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.bankreconciliation.NewMatch new_matches = 4; */
        for (let i = 0; i < message.newMatches.length; i++)
            NewMatch.internalBinaryWrite(message.newMatches[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.CompleteReconciliationReq
 */
export const CompleteReconciliationReq = new CompleteReconciliationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompleteReconciliationRes$Type extends MessageType<CompleteReconciliationRes> {
    constructor() {
        super("rd.api.bankreconciliation.CompleteReconciliationRes", []);
    }
    create(value?: PartialMessage<CompleteReconciliationRes>): CompleteReconciliationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CompleteReconciliationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CompleteReconciliationRes): CompleteReconciliationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CompleteReconciliationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.CompleteReconciliationRes
 */
export const CompleteReconciliationRes = new CompleteReconciliationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidReconciliationReq$Type extends MessageType<VoidReconciliationReq> {
    constructor() {
        super("rd.api.bankreconciliation.VoidReconciliationReq", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<VoidReconciliationReq>): VoidReconciliationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<VoidReconciliationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidReconciliationReq): VoidReconciliationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidReconciliationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.VoidReconciliationReq
 */
export const VoidReconciliationReq = new VoidReconciliationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidReconciliationRes$Type extends MessageType<VoidReconciliationRes> {
    constructor() {
        super("rd.api.bankreconciliation.VoidReconciliationRes", []);
    }
    create(value?: PartialMessage<VoidReconciliationRes>): VoidReconciliationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VoidReconciliationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidReconciliationRes): VoidReconciliationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidReconciliationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.VoidReconciliationRes
 */
export const VoidReconciliationRes = new VoidReconciliationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReopenReconciliationReq$Type extends MessageType<ReopenReconciliationReq> {
    constructor() {
        super("rd.api.bankreconciliation.ReopenReconciliationReq", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReopenReconciliationReq>): ReopenReconciliationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReopenReconciliationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReopenReconciliationReq): ReopenReconciliationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReopenReconciliationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.ReopenReconciliationReq
 */
export const ReopenReconciliationReq = new ReopenReconciliationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReopenReconciliationRes$Type extends MessageType<ReopenReconciliationRes> {
    constructor() {
        super("rd.api.bankreconciliation.ReopenReconciliationRes", []);
    }
    create(value?: PartialMessage<ReopenReconciliationRes>): ReopenReconciliationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReopenReconciliationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReopenReconciliationRes): ReopenReconciliationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReopenReconciliationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.ReopenReconciliationRes
 */
export const ReopenReconciliationRes = new ReopenReconciliationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordMatchingTransactionReq$Type extends MessageType<RecordMatchingTransactionReq> {
    constructor() {
        super("rd.api.bankreconciliation.RecordMatchingTransactionReq", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "imported_transaction_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "allocations_by_chart_of_account_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money }, options: { "rd.validator.require": true } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "payment_method", kind: "enum", T: () => ["rd.accounting.ExternalTransaction.PaymentMethod", ExternalTransaction_PaymentMethod, "PAYMENT_METHOD_"], options: { "rd.validator.require": true } },
            { no: 6, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 7, name: "customer_id", kind: "message", T: () => UUID },
            { no: 8, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 9, name: "transacted_at", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<RecordMatchingTransactionReq>): RecordMatchingTransactionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.importedTransactionIds = [];
        message.allocationsByChartOfAccountId = {};
        message.description = "";
        message.paymentMethod = 0;
        if (value !== undefined)
            reflectionMergePartial<RecordMatchingTransactionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RecordMatchingTransactionReq): RecordMatchingTransactionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                case /* repeated rd.proto.uuid.UUID imported_transaction_ids */ 2:
                    message.importedTransactionIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id */ 3:
                    this.binaryReadMap3(message.allocationsByChartOfAccountId, reader, options);
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* rd.accounting.ExternalTransaction.PaymentMethod payment_method */ 5:
                    message.paymentMethod = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 6:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 7:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 8:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* google.protobuf.Timestamp transacted_at */ 9:
                    message.transactedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.transactedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: RecordMatchingTransactionReq["allocationsByChartOfAccountId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof RecordMatchingTransactionReq["allocationsByChartOfAccountId"] | undefined, val: RecordMatchingTransactionReq["allocationsByChartOfAccountId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.bankreconciliation.RecordMatchingTransactionReq.allocations_by_chart_of_account_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: RecordMatchingTransactionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID imported_transaction_ids = 2; */
        for (let i = 0; i < message.importedTransactionIds.length; i++)
            UUID.internalBinaryWrite(message.importedTransactionIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 3; */
        for (let k of globalThis.Object.keys(message.allocationsByChartOfAccountId)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsByChartOfAccountId[k], writer, options);
            writer.join().join();
        }
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* rd.accounting.ExternalTransaction.PaymentMethod payment_method = 5; */
        if (message.paymentMethod !== 0)
            writer.tag(5, WireType.Varint).int32(message.paymentMethod);
        /* rd.proto.uuid.UUID location_id = 6; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 7; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 8; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp transacted_at = 9; */
        if (message.transactedAt)
            Timestamp.internalBinaryWrite(message.transactedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.RecordMatchingTransactionReq
 */
export const RecordMatchingTransactionReq = new RecordMatchingTransactionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordMatchingTransactionRes$Type extends MessageType<RecordMatchingTransactionRes> {
    constructor() {
        super("rd.api.bankreconciliation.RecordMatchingTransactionRes", []);
    }
    create(value?: PartialMessage<RecordMatchingTransactionRes>): RecordMatchingTransactionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RecordMatchingTransactionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RecordMatchingTransactionRes): RecordMatchingTransactionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RecordMatchingTransactionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.RecordMatchingTransactionRes
 */
export const RecordMatchingTransactionRes = new RecordMatchingTransactionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportAndValidateStatementReq$Type extends MessageType<ImportAndValidateStatementReq> {
    constructor() {
        super("rd.api.bankreconciliation.ImportAndValidateStatementReq", [
            { no: 1, name: "external_account_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "statement_file", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ImportAndValidateStatementReq>): ImportAndValidateStatementReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statementFile = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<ImportAndValidateStatementReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImportAndValidateStatementReq): ImportAndValidateStatementReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID external_account_id */ 1:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                case /* bytes statement_file */ 2:
                    message.statementFile = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImportAndValidateStatementReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID external_account_id = 1; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bytes statement_file = 2; */
        if (message.statementFile.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.statementFile);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.ImportAndValidateStatementReq
 */
export const ImportAndValidateStatementReq = new ImportAndValidateStatementReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportAndValidateStatementRes$Type extends MessageType<ImportAndValidateStatementRes> {
    constructor() {
        super("rd.api.bankreconciliation.ImportAndValidateStatementRes", [
            { no: 1, name: "num_transactions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "suggested_start_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "suggested_end_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "suggested_starting_balance", kind: "message", T: () => Money },
            { no: 5, name: "suggested_ending_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<ImportAndValidateStatementRes>): ImportAndValidateStatementRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numTransactions = 0;
        if (value !== undefined)
            reflectionMergePartial<ImportAndValidateStatementRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImportAndValidateStatementRes): ImportAndValidateStatementRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 num_transactions */ 1:
                    message.numTransactions = reader.int32();
                    break;
                case /* google.protobuf.Timestamp suggested_start_date */ 2:
                    message.suggestedStartDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.suggestedStartDate);
                    break;
                case /* google.protobuf.Timestamp suggested_end_date */ 3:
                    message.suggestedEndDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.suggestedEndDate);
                    break;
                case /* rd.proto.money.Money suggested_starting_balance */ 4:
                    message.suggestedStartingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedStartingBalance);
                    break;
                case /* rd.proto.money.Money suggested_ending_balance */ 5:
                    message.suggestedEndingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedEndingBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImportAndValidateStatementRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 num_transactions = 1; */
        if (message.numTransactions !== 0)
            writer.tag(1, WireType.Varint).int32(message.numTransactions);
        /* google.protobuf.Timestamp suggested_start_date = 2; */
        if (message.suggestedStartDate)
            Timestamp.internalBinaryWrite(message.suggestedStartDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp suggested_end_date = 3; */
        if (message.suggestedEndDate)
            Timestamp.internalBinaryWrite(message.suggestedEndDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money suggested_starting_balance = 4; */
        if (message.suggestedStartingBalance)
            Money.internalBinaryWrite(message.suggestedStartingBalance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money suggested_ending_balance = 5; */
        if (message.suggestedEndingBalance)
            Money.internalBinaryWrite(message.suggestedEndingBalance, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.ImportAndValidateStatementRes
 */
export const ImportAndValidateStatementRes = new ImportAndValidateStatementRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReconciliationReq$Type extends MessageType<GetReconciliationReq> {
    constructor() {
        super("rd.api.bankreconciliation.GetReconciliationReq", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetReconciliationReq>): GetReconciliationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetReconciliationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReconciliationReq): GetReconciliationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReconciliationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.GetReconciliationReq
 */
export const GetReconciliationReq = new GetReconciliationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReconciliationRes$Type extends MessageType<GetReconciliationRes> {
    constructor() {
        super("rd.api.bankreconciliation.GetReconciliationRes", [
            { no: 1, name: "reconciliation", kind: "message", T: () => BankReconciliation },
            { no: 2, name: "matches", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetReconciliationRes_MatchWithTransactions },
            { no: 3, name: "imported_transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ImportedTransaction },
            { no: 4, name: "unmatched_external_transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalTransaction },
            { no: 5, name: "account", kind: "message", T: () => ExternalAccount },
            { no: 6, name: "is_latest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetReconciliationRes>): GetReconciliationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.matches = [];
        message.importedTransactions = [];
        message.unmatchedExternalTransactions = [];
        message.isLatest = false;
        if (value !== undefined)
            reflectionMergePartial<GetReconciliationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReconciliationRes): GetReconciliationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bankreconciliation.BankReconciliation reconciliation */ 1:
                    message.reconciliation = BankReconciliation.internalBinaryRead(reader, reader.uint32(), options, message.reconciliation);
                    break;
                case /* repeated rd.api.bankreconciliation.GetReconciliationRes.MatchWithTransactions matches */ 2:
                    message.matches.push(GetReconciliationRes_MatchWithTransactions.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.bankreconciliation.ImportedTransaction imported_transactions */ 3:
                    message.importedTransactions.push(ImportedTransaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.accounting.ExternalTransaction unmatched_external_transactions */ 4:
                    message.unmatchedExternalTransactions.push(ExternalTransaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.accounting.ExternalAccount account */ 5:
                    message.account = ExternalAccount.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* bool is_latest */ 6:
                    message.isLatest = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReconciliationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bankreconciliation.BankReconciliation reconciliation = 1; */
        if (message.reconciliation)
            BankReconciliation.internalBinaryWrite(message.reconciliation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.bankreconciliation.GetReconciliationRes.MatchWithTransactions matches = 2; */
        for (let i = 0; i < message.matches.length; i++)
            GetReconciliationRes_MatchWithTransactions.internalBinaryWrite(message.matches[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.bankreconciliation.ImportedTransaction imported_transactions = 3; */
        for (let i = 0; i < message.importedTransactions.length; i++)
            ImportedTransaction.internalBinaryWrite(message.importedTransactions[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.ExternalTransaction unmatched_external_transactions = 4; */
        for (let i = 0; i < message.unmatchedExternalTransactions.length; i++)
            ExternalTransaction.internalBinaryWrite(message.unmatchedExternalTransactions[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.ExternalAccount account = 5; */
        if (message.account)
            ExternalAccount.internalBinaryWrite(message.account, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool is_latest = 6; */
        if (message.isLatest !== false)
            writer.tag(6, WireType.Varint).bool(message.isLatest);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.GetReconciliationRes
 */
export const GetReconciliationRes = new GetReconciliationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReconciliationRes_MatchWithTransactions$Type extends MessageType<GetReconciliationRes_MatchWithTransactions> {
    constructor() {
        super("rd.api.bankreconciliation.GetReconciliationRes.MatchWithTransactions", [
            { no: 1, name: "match", kind: "message", T: () => ReconciliationMatchGroup },
            { no: 2, name: "imported_transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ImportedTransaction },
            { no: 3, name: "external_transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalTransaction }
        ]);
    }
    create(value?: PartialMessage<GetReconciliationRes_MatchWithTransactions>): GetReconciliationRes_MatchWithTransactions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.importedTransactions = [];
        message.externalTransactions = [];
        if (value !== undefined)
            reflectionMergePartial<GetReconciliationRes_MatchWithTransactions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReconciliationRes_MatchWithTransactions): GetReconciliationRes_MatchWithTransactions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bankreconciliation.ReconciliationMatchGroup match */ 1:
                    message.match = ReconciliationMatchGroup.internalBinaryRead(reader, reader.uint32(), options, message.match);
                    break;
                case /* repeated rd.bankreconciliation.ImportedTransaction imported_transactions */ 2:
                    message.importedTransactions.push(ImportedTransaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.accounting.ExternalTransaction external_transactions */ 3:
                    message.externalTransactions.push(ExternalTransaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReconciliationRes_MatchWithTransactions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bankreconciliation.ReconciliationMatchGroup match = 1; */
        if (message.match)
            ReconciliationMatchGroup.internalBinaryWrite(message.match, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.bankreconciliation.ImportedTransaction imported_transactions = 2; */
        for (let i = 0; i < message.importedTransactions.length; i++)
            ImportedTransaction.internalBinaryWrite(message.importedTransactions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.ExternalTransaction external_transactions = 3; */
        for (let i = 0; i < message.externalTransactions.length; i++)
            ExternalTransaction.internalBinaryWrite(message.externalTransactions[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.GetReconciliationRes.MatchWithTransactions
 */
export const GetReconciliationRes_MatchWithTransactions = new GetReconciliationRes_MatchWithTransactions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReconciliationMatchesReq$Type extends MessageType<UpdateReconciliationMatchesReq> {
    constructor() {
        super("rd.api.bankreconciliation.UpdateReconciliationMatchesReq", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "delete_match_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "accepted_match_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "new_matches", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NewMatch }
        ]);
    }
    create(value?: PartialMessage<UpdateReconciliationMatchesReq>): UpdateReconciliationMatchesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.deleteMatchIds = [];
        message.acceptedMatchIds = [];
        message.newMatches = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateReconciliationMatchesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateReconciliationMatchesReq): UpdateReconciliationMatchesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                case /* repeated rd.proto.uuid.UUID delete_match_ids */ 2:
                    message.deleteMatchIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID accepted_match_ids */ 3:
                    message.acceptedMatchIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.api.bankreconciliation.NewMatch new_matches */ 4:
                    message.newMatches.push(NewMatch.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateReconciliationMatchesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID delete_match_ids = 2; */
        for (let i = 0; i < message.deleteMatchIds.length; i++)
            UUID.internalBinaryWrite(message.deleteMatchIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID accepted_match_ids = 3; */
        for (let i = 0; i < message.acceptedMatchIds.length; i++)
            UUID.internalBinaryWrite(message.acceptedMatchIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.bankreconciliation.NewMatch new_matches = 4; */
        for (let i = 0; i < message.newMatches.length; i++)
            NewMatch.internalBinaryWrite(message.newMatches[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.UpdateReconciliationMatchesReq
 */
export const UpdateReconciliationMatchesReq = new UpdateReconciliationMatchesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReconciliationMatchesRes$Type extends MessageType<UpdateReconciliationMatchesRes> {
    constructor() {
        super("rd.api.bankreconciliation.UpdateReconciliationMatchesRes", []);
    }
    create(value?: PartialMessage<UpdateReconciliationMatchesRes>): UpdateReconciliationMatchesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateReconciliationMatchesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateReconciliationMatchesRes): UpdateReconciliationMatchesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateReconciliationMatchesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.UpdateReconciliationMatchesRes
 */
export const UpdateReconciliationMatchesRes = new UpdateReconciliationMatchesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrintReconciliationPDFReq$Type extends MessageType<PrintReconciliationPDFReq> {
    constructor() {
        super("rd.api.bankreconciliation.PrintReconciliationPDFReq", [
            { no: 1, name: "reconciliation_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<PrintReconciliationPDFReq>): PrintReconciliationPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PrintReconciliationPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PrintReconciliationPDFReq): PrintReconciliationPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID reconciliation_id */ 1:
                    message.reconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.reconciliationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PrintReconciliationPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID reconciliation_id = 1; */
        if (message.reconciliationId)
            UUID.internalBinaryWrite(message.reconciliationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.PrintReconciliationPDFReq
 */
export const PrintReconciliationPDFReq = new PrintReconciliationPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrintReconciliationPDFRes$Type extends MessageType<PrintReconciliationPDFRes> {
    constructor() {
        super("rd.api.bankreconciliation.PrintReconciliationPDFRes", [
            { no: 1, name: "pdf_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PrintReconciliationPDFRes>): PrintReconciliationPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfBytes = new Uint8Array(0);
        message.fileName = "";
        if (value !== undefined)
            reflectionMergePartial<PrintReconciliationPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PrintReconciliationPDFRes): PrintReconciliationPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes pdf_bytes */ 1:
                    message.pdfBytes = reader.bytes();
                    break;
                case /* string file_name */ 2:
                    message.fileName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PrintReconciliationPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes pdf_bytes = 1; */
        if (message.pdfBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.pdfBytes);
        /* string file_name = 2; */
        if (message.fileName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fileName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.PrintReconciliationPDFRes
 */
export const PrintReconciliationPDFRes = new PrintReconciliationPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewMatch$Type extends MessageType<NewMatch> {
    constructor() {
        super("rd.api.bankreconciliation.NewMatch", [
            { no: 1, name: "imported_transaction_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 2, name: "external_transaction_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<NewMatch>): NewMatch {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.importedTransactionIds = [];
        message.externalTransactionIds = [];
        if (value !== undefined)
            reflectionMergePartial<NewMatch>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NewMatch): NewMatch {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID imported_transaction_ids */ 1:
                    message.importedTransactionIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID external_transaction_ids */ 2:
                    message.externalTransactionIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NewMatch, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID imported_transaction_ids = 1; */
        for (let i = 0; i < message.importedTransactionIds.length; i++)
            UUID.internalBinaryWrite(message.importedTransactionIds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID external_transaction_ids = 2; */
        for (let i = 0; i < message.externalTransactionIds.length; i++)
            UUID.internalBinaryWrite(message.externalTransactionIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.bankreconciliation.NewMatch
 */
export const NewMatch = new NewMatch$Type();
/**
 * @generated ServiceType for protobuf service rd.api.bankreconciliation.BankReconciliationService
 */
export const BankReconciliationService = new ServiceType("rd.api.bankreconciliation.BankReconciliationService", [
    { name: "ListAccountsAndReconciliations", options: {}, I: ListAccountsAndReconciliationsReq, O: ListAccountsAndReconciliationsRes },
    { name: "CreateReconciliation", options: {}, I: CreateReconciliationReq, O: CreateReconciliationRes },
    { name: "GetReconciliation", options: {}, I: GetReconciliationReq, O: GetReconciliationRes },
    { name: "CompleteReconciliation", options: {}, I: CompleteReconciliationReq, O: CompleteReconciliationRes },
    { name: "VoidReconciliation", options: {}, I: VoidReconciliationReq, O: VoidReconciliationRes },
    { name: "ReopenReconciliation", options: {}, I: ReopenReconciliationReq, O: ReopenReconciliationRes },
    { name: "RecordMatchingTransaction", options: {}, I: RecordMatchingTransactionReq, O: RecordMatchingTransactionRes },
    { name: "UpdateReconciliationMatches", options: {}, I: UpdateReconciliationMatchesReq, O: UpdateReconciliationMatchesRes },
    { name: "PrintReconciliationPDF", options: {}, I: PrintReconciliationPDFReq, O: PrintReconciliationPDFRes },
    { name: "ImportAndValidateStatement", options: {}, I: ImportAndValidateStatementReq, O: ImportAndValidateStatementRes }
]);
